// client/src/pages/Home.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import HomeComponent from '../components/HomeComponent';
import '../styles/Home.css';

function Home() {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="container">
          <h1>Intelligente Aktienanalyse & Portfolio-Management</h1>
          <p className="hero-subtitle">
            Entdecke, analysiere und verfolge Aktien für dein Portfolio
          </p>
          <div className="hero-buttons">
            <Link to="/search" className="primary-button">
              <i className="fas fa-search"></i>
              Suche starten
            </Link>
            {!isAuthenticated && (
              <Link to="/login" className="secondary-button">
                <i className="fas fa-user-plus"></i>
                Anmelden
              </Link>
            )}
          </div>
        </div>
      </div>


      {/* CTA Section */}
      <div className="cta-section">
        <div className="container">
          <HomeComponent />
        </div>
      </div>
    </div>
  );
}

export default Home;